import LazyLoad from "vanilla-lazyload";
//import Masonry from "masonry-layout";
//import Cookies from "js-cookie";
const Flickity = require("flickity-fade");
import socialIcons from "social-icons";
import arRows from "ar-rows";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollSmoother from "gsap/ScrollSmoother";
import SplitText from "gsap/SplitText";
gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);
import zenscroll from "zenscroll";
import hoverintent from "hoverintent";

/* SETUP VARS */
let bw = document.body.scrollWidth;
let dpr = window.devicePixelRatio;
const body = document.querySelector("body");
const menuBtn = document.querySelector(".menuBtn");
let socialEl = document.querySelectorAll(".social");
let rowsEl = document.querySelectorAll(".ar-rows");
const nav = document.querySelector("nav");
const overlay = document.getElementById("overlay");
if (typeof overlay != "undefined" && overlay != null) {
  const overlayInner = overlay.querySelector(".inner");
  const overlayCloser = overlay.querySelector(".closer");
}

window.addEventListener("load", function () {
  body.classList.remove("preload");
});

document.addEventListener("DOMContentLoaded", function () {
  /* ***************************************** */
  /* INITIALIZATION ON PAGE LOAD */
  /* ***************************************** */

  // site wide smooth scroll
  ScrollSmoother.create({
    smooth: 1.5,
    effects: true,
  });

  /*
  // pin the breadcrumb to top of page
  let breadcrumbEl = document.querySelector(".breadcrumb");
  if (typeof breadcrumbEl != "undefined" && breadcrumbEl != null) {
    let mm = gsap.matchMedia();

    mm.add("(min-width: 768px)", () => {
      ScrollTrigger.create({
        trigger: "article.gridpage",
        start: "top top",
        end: "bottom top",
        pin: breadcrumbEl,
        pinSpacing: false,
      });
    });
  }
  */

  // textpage text reveal
  let textpageEl = document.querySelector(".textpage");
  if (typeof textpageEl != "undefined" && textpageEl != null) {
    animateTextPage(textpageEl);
  }

  function animateTextPage(parent) {
    let bio = parent.querySelector(".bio");
    let headline = parent.querySelector(".bio h1");
    let body = parent.querySelector(".bio p");
    let contacts = parent.querySelector(".contacts");
    let headlineSplit = new SplitText(headline, { type: "lines" });

    if (innerWidth > 767) {
      // desktop, trigger animation on page load
      let tl = gsap.timeline({ defaults: { ease: "power3.Out" } });
      gsap.set(bio, { opacity: 1 });
      tl.from(headlineSplit.lines, {
        y: 50,
        opacity: 0,
        duration: 0.5,
        stagger: 0.1,
      })
        .from(body, {
          opacity: 0,
          duration: 0.5,
        })
        .to(contacts, { opacity: 1, y: 0, duration: 0.5 });
    } else {
      // mobile, trigger animation on scrollTrigger
      let tl = gsap.timeline({ defaults: { ease: "power3.Out" } });
      gsap.set(contacts, { opacity: 1, y: 0 });
      gsap.set(bio, { opacity: 1 });
      gsap.set(headlineSplit.lines, { opacity: 0, y: 50 });

      // fade on contacts
      tl.from(contacts, { opacity: 0, y: 20, duration: 0.5 });

      // scrollTrigger reveal for headline and body
      ScrollTrigger.create({
        trigger: headline,
        start: "top 80%",
        onEnter: () => {
          let tl = gsap.timeline({ defaults: { ease: "power3.Out" } });
          tl.to(headlineSplit.lines, {
            y: 0,
            opacity: 1,
            duration: 0.5,
            stagger: 0.1,
          }).from(body, {
            opacity: 0,
            duration: 0.5,
          });
        },
      });

      /*
        .to(body, {
          opacity: 1,
          duration: 0.5,
        })
        .from(headlineSplit.lines, {
          y: 50,
          opacity: 0,
          duration: 0.5,
          stagger: 0.1,
        });
        */
    }
    //let bodySplit = new SplitText(body, { type: "lines" });
  }

  // stagger reveal submenu items
  let subNavItems = document.querySelectorAll("header .subs li");
  gsap.set(subNavItems, { opacity: 0, y: -10 });

  // global animation effects
  ScrollTrigger.batch(".fadeUp", {
    onEnter: (elements, triggers) => {
      gsap.to(elements, { opacity: 1, y: 0, stagger: 0.15 });
    },
  });

  ScrollTrigger.batch(".fadeOn", {
    onEnter: (elements, triggers) => {
      gsap.to(elements, { opacity: 1, stagger: 0.1 });
    },
  });

  setTimeout(function () {
    ScrollTrigger.batch(".fadeUpDelay", {
      onEnter: (elements, triggers) => {
        gsap.to(elements, { opacity: 1, y: 0, stagger: 0.15 });
      },
    });
  }, 300);

  // check for any social icons
  if (typeof socialIcons != "undefined") {
    socialIcons(socialEl);
  }

  // init AR Rows type layout
  if (typeof arRows != "undefined") {
    arRows(rowsEl);
  }

  // any cols from text editor need to be wrapped in cols class
  let textCols = document.querySelectorAll(".text-block");
  for (var i = 0; i < textCols.length; i++) {
    wrapCols(textCols[i]);
  }

  ScrollTrigger.batch(".loadmeview", {
    onEnter: (elements, triggers) => {
      elements.forEach((element) => {
        loadImage(element);
      });
    },
    start: "top bottom+=" + innerHeight,
  });

  /*
  //initialize lazyload - sitewide for image
  const lazyLoad = new LazyLoad({
    elements_selector: ".loadmeview",
    threshold: 1000,
    callback_enter: loadImage,
  });
  */

  //initialize lazyload - autoplay videos
  const lazyLoadAutoVideo = new LazyLoad({
    elements_selector: ".autovideo",
    threshold: 30,
    callback_enter: playAutoVideo,
    callback_exit: pauseAutoVideo,
  });

  // initialize masonry

  let masonGrids = document.querySelectorAll(".masongrid");
  masonGrids.forEach((masonGrid) => {
    //injecting bottom margin into masonry cell
    let gutterWidth = masonGrid.querySelector(".gutter-sizer").scrollWidth;
    let cells = masonGrid.getElementsByClassName("cell");
    for (var i = 0; i < cells.length; i++) {
      cells[i].style.marginBottom = gutterWidth + "px";
    }

    const msnry = new Masonry(masonGrid, {
      itemSelector: ".cell",
      columnWidth: ".grid-sizer",
      gutter: ".gutter-sizer",
    });
    msnry.layout();

    function onLayoutComplete() {
      // run lazyload after masonry has run
      const masonLoad = new LazyLoad({
        elements_selector: ".masonlazy",
      });
    }
    msnry.on("layoutComplete", onLayoutComplete);
  });

  //initialize flickity for slideshows

  let slideshowEl = document.querySelector(".slideshow");

  if (typeof slideshowEl != "undefined" && slideshowEl != null) {
    let flkty;

    let slideshowWrap = document.querySelector(".slideshowpage");

    function goToSlide(index) {
      flkty.select(index);
      loadSlide();
    }

    function loadSlide() {
      // pause any playing videos
      let cells = slideshowEl.querySelectorAll(".cell");
      cells.forEach((cell) => {
        if (cell.classList.contains("video")) {
          let videoEl = cell.querySelector("video");
          if (typeof videoEl != "undefined" && videoEl != null) {
            videoEl.pause();
          }
        }
      });

      // target the selected cell
      let cell = slideshowEl.querySelector(".is-selected");
      // load media
      if (cell.classList.contains("video")) {
        let videoEl = cell.querySelector("video");
        if (typeof videoEl != "undefined" && videoEl != null) {
          if (videoEl.classList.contains("sizeload")) {
            sizeloadVideo(videoEl, "yes");
          }
          videoEl.play();
        } else {
          let videoStr = cell.getAttribute("data-video");
          let videoHold = cell.querySelector(".vidhold");
          videoHold.innerHTML = videoStr;
          videoEl = videoHold.querySelector("video");
          if (videoEl.classList.contains("sizeload")) {
            sizeloadVideo(videoEl, "yes");
          }
          videoEl.play();
        }
      } else {
        loadImage(cell.querySelector("img.photo"));
      }

      // load the next cell ahead of time
      let nextCell = cell.nextElementSibling;
      if (nextCell) {
        if (nextCell.classList.contains("video")) {
          let videoEl = nextCell.querySelector("video");
          if (typeof videoEl != "undefined" && videoEl != null) {
            if (videoEl.classList.contains("sizeload")) {
              sizeloadVideo(videoEl, "yes");
            }
          } else {
            let videoStr = nextCell.getAttribute("data-video");
            let videoHold = nextCell.querySelector(".vidhold");
            videoHold.innerHTML = videoStr;
            videoEl = videoHold.querySelector("video");
            if (videoEl.classList.contains("sizeload")) {
              sizeloadVideo(videoEl, "yes");
            }
          }
        } else {
          loadImage(nextCell.querySelector("img.photo"));
        }
      }

      // update the window hash value
      let cellId = cell.getAttribute("data-id");
      window.location.hash = cellId;
      // update the close link
      let closeEl = document.querySelector(".closeLink");
      let closeLink = closeEl.getAttribute("data-link");

      closeLink = closeLink + "#" + cellId;
      closeEl.setAttribute("href", closeLink);
    }

    flkty = new Flickity(slideshowEl, {
      // options
      fade: true,
      cellSelector: ".cell",
      pageDots: false,
      prevNextButtons: false,
      wrapAround: true,
      draggable: false,
      on: {
        ready: function () {
          slideshowEl.focus();
        },
      },
    });

    // check for hash in URL and go to slide
    let hash = window.location.hash;
    if (hash) {
      let hashIndex = hash.replace("#", "");
      --hashIndex;
      goToSlide(hashIndex);
      setTimeout(function () {
        loadSlide();
        slideshowEl.style.opacity = 1;
      }, 300);
    } else {
      loadSlide();
      slideshowEl.style.opacity = 1;
    }

    // on change, update the close link with the new data-id value
    flkty.on("change", function (index) {
      loadSlide();
    });

    // setup custom cursor events
    const cursor = document.querySelector("#cursor");

    const positionCursor = (e) => {
      const mouseY = e.clientY - 43;
      const mouseX = e.clientX - 43;

      cursor.style.transform = `translate3d(${mouseX}px, ${mouseY}px, 0)`;
    };

    slideshowWrap.addEventListener("mousemove", (e) => {
      positionCursor(e);
      body.classList.remove("cursor_left", "cursor_right");
      if (e.pageX >= innerWidth / 2) {
        body.classList.add("cursor_right");
      } else {
        body.classList.add("cursor_left");
      }
    });

    slideshowWrap.addEventListener("mouseleave", (e) => {
      body.classList.remove("cursor_left", "cursor_right");
    });

    // turn off the custom cursor when hovering over the vidhold element
    let vidHolds = slideshowEl.querySelectorAll(".vidhold");
    vidHolds.forEach((vidHold) => {
      vidHold.addEventListener("mouseenter", (e) => {
        cursor.style.opacity = 0;
      });
      vidHold.addEventListener("mouseleave", (e) => {
        cursor.style.opacity = 1;
      });
    });

    slideshowWrap.addEventListener("click", (e) => {
      // if e.target is video return
      if (e.target.tagName === "VIDEO") {
        return;
      }

      if (e.pageX >= innerWidth / 2) {
        flkty.next();
      } else {
        flkty.previous();
      }
    });
  }

  /* HANDLE CELLS THAT REQUIRE RATIO SIZING */
  let ratioCells = document.getElementsByClassName("ratioSize");
  for (let i = 0; i < ratioCells.length; i++) {
    ratioSize(ratioCells[i]);
  }

  /* HANDLE IMAGES THAT REQUIRE RESIZE IMAGE FUNCTION */
  let resizeImageCells = document.getElementsByClassName("resize-image");
  for (let i = 0; i < resizeImageCells.length; i++) {
    resizeImage(resizeImageCells[i]);
  }

  /* ***************************************** */
  /* FUNCTIONS */
  /* ***************************************** */

  function sizeloadVideo(el, preload) {
    let desktopSrc = el.getAttribute("data-hd"),
      mobileSrc = el.getAttribute("data-sd"),
      videoSourceEl = el.querySelector("source");

    if (window.innerWidth > 896) {
      videoSourceEl.setAttribute("src", desktopSrc);
    } else {
      videoSourceEl.setAttribute("src", mobileSrc);
    }
    el.load();
    if (preload !== "yes") {
      el.play();
    }
  }

  function playAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector("video");
    if (typeof videoEl != "undefined" && videoEl != null) {
      videoEl.play();
    } else {
      let videoStr = el.getAttribute("data-gridvideo");
      let videoHold = el.querySelector(".vidhold");
      videoHold.innerHTML = videoStr;
      videoEl = videoHold.querySelector("video");
      videoEl.play();
    }
    el.classList.add("playing");
  }

  function pauseAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector("video");
    videoEl.pause();
    el.classList.remove("playing");
  }

  function loadImage(image) {
    if (image.classList.contains("loaded")) {
      return;
    }

    let img = image.getAttribute("data-img"),
      newW = image.classList.contains("bg-loadme")
        ? image.offsetWidth * dpr
        : image.parentNode.offsetWidth * dpr,
      fullpath = "",
      imgpath = "";

    if (newW <= 500) {
      //imgpath = "/images/pics/500/" + img;
      imgpath =
        "https://res.cloudinary.com/dmi14ozrz/image/upload/f_auto,fl_lossy,q_auto:best,w_500/" +
        img;
    } else if (newW > 500 && newW <= 750) {
      //imgpath = "/images/pics/750/" + img;
      imgpath =
        "https://res.cloudinary.com/dmi14ozrz/image/upload/f_auto,fl_lossy,q_auto:best,w_750/" +
        img;
    } else if (newW > 750 && newW <= 1000) {
      //imgpath = "/images/pics/1000/" + img;
      imgpath =
        "https://res.cloudinary.com/dmi14ozrz/image/upload/f_auto,fl_lossy,q_auto:best,w_1000/" +
        img;
    } else if (newW > 1000 && newW <= 1536) {
      //imgpath = "/images/pics/1536/" + img;
      imgpath =
        "https://res.cloudinary.com/dmi14ozrz/image/upload/f_auto,fl_lossy,q_auto:best,w_1536/" +
        img;
    } else if (newW > 1536 && newW <= 1920) {
      //imgpath = "/images/pics/1920/" + img;
      imgpath =
        "https://res.cloudinary.com/dmi14ozrz/image/upload/f_auto,fl_lossy,q_auto:best,w_1920/" +
        img;
    } else {
      //imgpath = "/images/pics/" + img;
      imgpath =
        "https://res.cloudinary.com/dmi14ozrz/image/upload/f_auto,fl_lossy,q_auto:best/" +
        img;
    }

    if (image.classList.contains("bg-loadme")) {
      $("<img/>")
        .attr("src", imgpath)
        .on("load", function () {
          $(this).remove();
          image
            .css("background-image", "url(" + imgpath + ")")
            .addClass("loaded");
        });
    } else {
      let newimage = new Image();
      newimage.onload = function () {
        image.src = imgpath;
        //image.classList.add("loaded");
      };
      newimage.src = imgpath;
    }
  }

  function wrapCols(el) {
    let elContainer = document.createElement("div");
    Array.prototype.forEach.call(el.querySelectorAll(".col"), function (c) {
      elContainer.appendChild(c);
    });
    elContainer.classList.add("cols");
    el.appendChild(elContainer);
  }

  // AJAX GET
  function getAjax(url, success) {
    var xhr = window.XMLHttpRequest
      ? new XMLHttpRequest()
      : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open("GET", url);
    xhr.onreadystatechange = function () {
      if (xhr.readyState > 3 && xhr.status == 200) success(xhr.responseText);
    };
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.send();
    return xhr;
  }

  function openOverlay() {
    overlay.classList.add("on");
  }

  function closeOverlay() {
    overlay.classList.remove("on");
    overlayInner.innerHTML = "";
  }

  function ratioSize(el) {
    let width = el.scrollWidth,
      ratio = el.getAttribute("data-ratio"),
      height = Math.floor(width * ratio);

    el.style.height = height + "px";
  }

  function resizeImage(el) {
    let photo = el.getElementsByClassName("photo"),
      parentWidth = Math.floor(el.scrollWidth),
      parentHeight = Math.floor(el.scrollHeight),
      parentRatio = parentHeight / parentWidth,
      photoRatio = photo[0].getAttribute("data-aspect-ratio");

    if (photoRatio >= parentRatio) {
      photo[0].classList.add("size-width");
      photo[0].classList.remove("size-height");
    } else {
      photo[0].classList.add("size-height");
      photo[0].classList.remove("size-width");
    }
  }

  function resizeFrame(el) {
    let parent = el.closest(".vidhold"),
      pw = parent.offsetWidth,
      ph = parent.offsetHeight,
      pr = ph / pw,
      orgW = el.getAttribute("width"),
      orgH = el.getAttribute("height"),
      r = orgH / orgW;

    if (r <= pr) {
      var nw = pw;
      var nh = nw * r;
    } else {
      var nw = ph / r,
        nh = ph;
    }

    el.setAttribute("width", nw);
    el.setAttribute("height", nh);
  }

  /* HANDLE WINDOW RESIZE */

  function reportWindowSize() {}

  window.addEventListener("resize", reportWindowSize);

  /* ***************************************** */
  /* EVENTS */
  /* ***************************************** */

  // setup listener for hovervideo
  let hoverVideos = document.querySelectorAll(".hovervideo");
  hoverVideos.forEach((hoverVideo) => {
    hoverVideo.addEventListener("mouseenter", function () {
      playAutoVideo(hoverVideo);
    });
    hoverVideo.addEventListener("mouseleave", function () {
      pauseAutoVideo(hoverVideo);
    });
  });

  // check for hash value on gridpages to scroll to item
  let hash = window.location.hash;
  let gridPageEl = document.querySelector("article.gridpage");
  if (hash && typeof gridPageEl != "undefined" && gridPageEl != null) {
    let targetEl = document.getElementById(hash.replace("#", ""));
    zenscroll.intoView(targetEl);
  }

  // header submenu reveal
  let menuSubTriggers = document.querySelectorAll("li.hasSubs");
  let nextMenuItem = document.querySelector("li.hasSubs + li");
  let social = document.querySelector("li.social");

  menuSubTriggers.forEach((menuSubTrigger) => {
    //NOTE: unsure now to get innerwidth of window to update on resize. Mobile nav animation
    //not working properly when resize from desktop. Have to reload page
    // let onresize = function () { window_width = e.target.innerWidth; };
    // window.addEventListener("resize", onresize);

    let subNav = menuSubTrigger.querySelector(".subs");
    let subNavItems = subNav.querySelectorAll("li");

    if (innerWidth <= 767) {
      menuSubTrigger.addEventListener("click", function (e) {
        e.preventDefault();
        if (subNav.classList.contains("active")) {
          let subNavTL = gsap.timeline();
          subNavTL
            .to(subNavItems, { opacity: 0, stagger: 0.05, duration: 0.2 })
            .to(subNav, { scaleY: 0, duration: 0.4, ease: "power3.Out" }, 0.2);

          let nextMenuItemTL = gsap.timeline();
          nextMenuItemTL.to(
            nextMenuItem,
            {
              y: 0,
              duration: 0.6,
              ease: "power3.Out",
            },
            0.2
          );
          let socialTL = gsap.timeline();
          socialTL.to(
            social,
            {
              y: 0,
              duration: 0.6,
              ease: "power3.Out",
            },
            0.2
          );

          setTimeout(function () {
            subNav.classList.remove("active");
          }, 400);
        } else {
          subNav.classList.add("active");
          let subNavTL = gsap.timeline();
          subNavTL
            .to(subNav, { scaleY: 1, duration: 0.4, ease: "power3.Out" })
            .to(
              subNavItems,
              { opacity: 1, y: 0, stagger: 0.1, duration: 0.3 },
              "<"
            );

          let nextMenuItemTL = gsap.timeline();
          nextMenuItemTL.to(nextMenuItem, {
            scaleY: 1,
            y: subNav.scrollHeight + 10,
            duration: 0.8,
            ease: "power3.Out",
          });

          let socialTL = gsap.timeline();
          socialTL.to(social, {
            scaleY: 1,
            y: subNav.scrollHeight + 10,
            duration: 0.8,
            ease: "power3.Out",
          });
          // menuSubTrigger.classList.add("open");
        }
        subNavItems.forEach((subNavItem) => {
          subNavItem.addEventListener("click", function (e) {
            e.preventDefault();
            window.location.href = subNavItem
              .querySelector("a")
              .getAttribute("href");
          });
        });
      });
    } else {
      hoverintent(
        menuSubTrigger,
        function () {
          // Handler in
          subNav.classList.add("active");
          let subNavTL = gsap.timeline();
          subNavTL
            .to(subNav, { scaleY: 1, duration: 0.4, ease: "power3.Out" })
            .to(
              subNavItems,
              { opacity: 1, y: 0, stagger: 0.1, duration: 0.3 },
              "<"
            );
          menuSubTrigger.classList.add("open");
          //Tried to test if the nav below would also push downwards to make way for the subnav,
          //but it didn't work
          // nextSubNav.classList.add("push");
          // let nextSubNavTL = gsap.timeline();
          // nextSubNavTL.to(nextSubnav, {
          //   scaleY: 1,
          //   duration: 0.4,
          //   ease: "power3.Out",
          // });
        },
        function () {
          // Handler out
          subNav.classList.remove("active");
          let subNavTL = gsap.timeline();
          subNavTL
            .to(subNavItems, { opacity: 0, stagger: 0.05, duration: 0.2 })
            .to(subNav, { scaleY: 0, duration: 0.4, ease: "power3.Out" }, 0.2);
        }
      );
    }
  });

  // overlay links
  let overlayLinks = document.querySelectorAll(".openOverlay");
  overlayLinks.forEach((overlayLink) => {
    overlayLink.addEventListener("click", function (e) {
      e.preventDefault();
      let id = overlayLink.getAttribute("data-id");
      getAjax("/getItem.php?id=" + id, function (data) {
        overlayInner.innerHTML = data;
        openOverlay();
      });
    });
  });

  //hamburger menu toggle
  if (typeof menuBtn != "undefined" && menuBtn != null) {
    menuBtn.addEventListener(
      "click",
      function (event) {
        event.preventDefault(), document.body.classList.toggle("menuOn");
      },
      true
    );
  }

  // close overlay
  if (typeof overlay != "undefined" && overlay != null) {
    overlayCloser.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        closeOverlay();
      },
      true
    );
  }

  // example link for AJAX request
  const ajaxLink = document.querySelector("a.ajax");
  if (typeof ajaxLink != "undefined" && ajaxLink != null) {
    ajaxLink.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        // caption slug for URL
        let linkSlug = this.getAttribute("data-slug");
        window.location.hash = linkSlug;

        // ajax call to get page text
        getAjax("/getTextpage.php?slug=" + linkSlug, function (data) {
          // load data into overlay
          overlayInner.innerHTML = data;
          overlay.classList.add("on");
          // return side nav to "off" state
          nav.classList.remove("open");
          // add blur class to body
          body.classList.add("blur");
        });
      },
      true
    );
  }
});
